import { render } from "./AppHeaderAdmin.vue?vue&type=template&id=6fe8f196"
import script from "./AppHeaderAdmin.vue?vue&type=script&lang=js"
export * from "./AppHeaderAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__